import Cookie from 'js-cookie';
import { ACP_LANGUAGE_COOKIE_NAME, TMS_LANGUAGE_COOKIE_NAME } from './locale';
export const DEFAULT_COOKIE_EXPIRATION_DAYS = 365;
const LANGUAGE_COOKIES = {
    ACP: ACP_LANGUAGE_COOKIE_NAME,
    TMS: TMS_LANGUAGE_COOKIE_NAME,
};
export function getCommonDefaultLanguage(appName, defaultLanguage) {
    const lang = Cookie.get(LANGUAGE_COOKIES[appName]);
    return lang || defaultLanguage;
}
export function setCommonDefaultLanguage(appName, defaultLanguage, expirationDays = DEFAULT_COOKIE_EXPIRATION_DAYS) {
    if (!Cookie.get(LANGUAGE_COOKIES[appName])) {
        Cookie.set(LANGUAGE_COOKIES[appName], defaultLanguage, {
            expires: expirationDays,
        });
    }
}
export function setCommonLanguage(appName, language, expirationDays = DEFAULT_COOKIE_EXPIRATION_DAYS) {
    Cookie.set(LANGUAGE_COOKIES[appName], language, {
        expires: expirationDays,
    });
}
